const ADD_NEW_ID = "ADD_NEW_ID";
const DROP_IDS = "DROP_IDS";

export const addNewID = (name, value) => {
  return {
    type: ADD_NEW_ID,
    name,
    value
  };
};

export const dropIds = () => (
  {
    type: DROP_IDS
  }
);
